var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-inner-loading',{attrs:{"showing":_vm.show}},[_c('q-spinner-gears',{attrs:{"size":"50px","color":"primary"}}),_vm._v("\n      Processing Payment.. Please don't leave this page.\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }